import richText from "utilities/richText"
import Arrow from "/public/assets/handwritten/handwritten-arrow.svg"
import LinedCircle from "/public/assets/decorative-patterns/lined-circle.svg"
import PlusPattern from "/public/assets/decorative-patterns/plus-pattern.svg"
import CallToAction from "components/CallToAction"

export default function SidebarSection({ className, content }) {
  return (
    <section className={className}>
      <div className="container flex flex-col lg:flex-row justify-between max-w-screen-xl 2xl:max-w-screen-2xl m-auto py-16 2xl:py-24 gap-4">
        <div className="lg:w-3/5 max-w-full prose 2xl:max-w-[80ch] mx-auto lg:mx-0 lg:pr-8 2xl:pr-16">
          {richText(content)}
        </div>
        <aside className="lg:w-2/5 relative pt-2">
          <div className="relative lg:sticky lg:top-8 bg-kelly-to-lime text-center rounded-3xl p-10 px-8 text-blue overflow-hidden">
            <div className="absolute z-0 top-3 -right-8 size-32 overflow-hidden">
              <LinedCircle className="size-32 fill-green-kelly opacity-50" />
            </div>
            <div className="relative max-w-48 mx-auto pb-8 pr-4 font-tertiary text-m3 -rotate-6 block leading-6 font-light">
              Questions? Comments?
              <br />A good joke?
              <Arrow className="rotate-2 absolute -bottom-2 left-[65%] size-14" />
            </div>
            <h2 className="mt-1 mb-4 font-semibold text-m3 lg:text-l1 z-10 relative text-blue">
              We&apos;d Love to Hear <span className="inline-block">From You.</span>
            </h2>
            <CallToAction className="bg-white relative z-10" style="tertiary" href="/contact">
              Get in Touch
            </CallToAction>
            <div className="absolute z-0 top-36 -left-16 size-64 overflow-hidden">
              <PlusPattern className="mt-4 size-64 fill-green-lime" />
            </div>
          </div>
        </aside>
      </div>
    </section>
  )
}
